import { Asset } from 'contentful';
import { z } from 'zod';

export const ContentfulAssetSchema = z.looseObject({
  sys: z.object({
    id: z.string(),
    type: z.literal('Asset'),
    createdAt: z.string(),
    updatedAt: z.string(),
    locale: z.string(),
    space: z
      .object({
        sys: z.object({
          type: z.literal('Link'),
          linkType: z.literal('Space'),
          id: z.string()
        })
      })
      .optional()
      .nullable(),
    environment: z
      .object({
        sys: z.object({
          id: z.string(),
          type: z.literal('Link'),
          linkType: z.literal('Environment')
        })
      })
      .optional()
      .nullable(),
    revision: z.number().optional().nullable()
  }),
  fields: z.object({
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    file: z
      .object({
        url: z.string(),
        details: z
          .object({
            size: z.number(),
            image: z
              .object({
                width: z.number(),
                height: z.number()
              })
              .optional()
              .nullable()
          })
          .optional()
          .nullable(),
        fileName: z.string(),
        contentType: z.string()
      })
      .optional()
      .nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateAssetEntry(data: Asset) {
  return ContentfulAssetSchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateAssetEntries(data: Asset[]) {
  return z.array(ContentfulAssetSchema).safeParse(data);
}
